import { FC } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { ColorIcon } from '@ravago/shared/radiance/components/icon/components/ColorIcon/ColorIcon';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { TranslateFn, useTranslations } from '@ravago/shared/translations/client';

import { DEFAULT_PRODUCER_COLOR_CODE, OTHER_PRODUCER_COLOR_CODE, UNKNOWN_COLOR_ID, UNKNOWN_PRODUCER_COLOR_CODE } from '../../constants';

interface Props {
   colorId?: number;
   colorName: string;
   producerColorCode: string | undefined;
   desiredColor: string | undefined;
}

const generateFullColorLabel = (
   colorId: number | undefined,
   colorName: string,
   producerColorCode: string | undefined,
   desiredColor: string | undefined,
   translate: TranslateFn
) => {
   if (colorId === UNKNOWN_COLOR_ID) {
      return translate('colors.unknown');
   }
   let result = colorName;

   if (producerColorCode && producerColorCode !== DEFAULT_PRODUCER_COLOR_CODE) {
      let producerColorCodeToDisplay = producerColorCode;
      if (producerColorCodeToDisplay === UNKNOWN_PRODUCER_COLOR_CODE) {
         producerColorCodeToDisplay = translate('color-codes.unknown');
      } else if (producerColorCodeToDisplay === OTHER_PRODUCER_COLOR_CODE) {
         producerColorCodeToDisplay = translate('color-codes.other');
      }
      result = `${result} - ${producerColorCodeToDisplay}`;
   }
   if (desiredColor) result = `${result} - ${desiredColor}`;

   return result;
};

export const ProductFlyoutColorDetails: FC<Props> = ({ colorId, colorName, producerColorCode, desiredColor }: Props) => {
   const translate = useTranslations();

   const fullColorLabel = generateFullColorLabel(colorId, colorName, producerColorCode, desiredColor, translate);

   return (
      <Box direction="column" gap="2xs">
         <Typography component="span" variant="body-highlight">
            {translate('page-consumer.request-for-quotation.colour')}
         </Typography>
         <Box gap="2xs" items="center">
            <ColorIcon colorName={colorName?.toLowerCase()} />
            <Typography component="span" variant="body">
               {fullColorLabel}
            </Typography>
         </Box>
      </Box>
   );
};
